import * as React from 'react';
import { isArray, isString, uniq } from 'lodash';
import { FormHelperText } from '@material-ui/core';
import { getIn } from 'formik';

export interface FormikFieldProps {
  children: React.ReactNode;
  field: { name: string };
  form: {
    touched: any;
    errors: any;
    setTouched: (fields: { [field: string]: boolean }) => void;
    setFieldValue: (name: string, value: any, shouldValidate: boolean) => void;
  };
  showNoError: boolean;
  formHelperTextClassName: any;
}

const FormikField = (props: FormikFieldProps) => {
  const { children, field, form, showNoError = false, formHelperTextClassName } = props;

  if (showNoError) {
    return <>{children}</>;
  }

  const touched = getIn(form.touched, field.name);
  const error = getIn(form.errors, field.name);

  let currentError;
  if (touched && error) {
    if (isString(error)) {
      currentError = error;
    } else if (isArray(error)) {
      currentError = uniq(error).concat(', ');
    } else {
      currentError = error;
    }
  }

  return (
    <React.Fragment>
      {children}
      {currentError && (
        <FormHelperText error variant='filled' className={formHelperTextClassName}>
          {currentError}
        </FormHelperText>
      )}
    </React.Fragment>
  );
};

export default FormikField;
